var map = {
	"./bg-roulette.png": 2387,
	"./chat.png": 358,
	"./conectando.png": 9682,
	"./correcto.png": 2017,
	"./fase1.png": 8515,
	"./fase2.png": 4296,
	"./fase3.png": 8335,
	"./fase4.png": 1465,
	"./fondo.png": 8930,
	"./fondo_01.jpg": 257,
	"./gifLapiz_snFondo.gif": 4768,
	"./guess_word_error.png": 8480,
	"./guess_word_ok.png": 4271,
	"./img-home.png": 274,
	"./img-login.png": 9640,
	"./incorrecto.png": 943,
	"./logo_elektra_blanco.png": 4574,
	"./logo_grupo_elektra.png": 9609,
	"./logo_lideres.png": 3614,
	"./logo_lideres_completo.png": 855,
	"./logos_footer.png": 7618,
	"./pregunta1.png": 371,
	"./respuesta.png": 5696,
	"./roule-2.png": 7909,
	"./roulette.png": 2278,
	"./selector-rou.png": 5130,
	"./sinfondo_estrellita.gif": 1883,
	"./teclado.png": 6266,
	"./user.png": 8055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;